import buildsReducer from './ducks/container';

export default buildsReducer;
